var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shop-fanbox" }, [
    _c("div", { staticClass: "highlighted-section" }, [
      _c("div", { staticClass: "row shop-fanbox__teaser" }, [
        _c("div", { staticClass: "col-12 col-md-6 order-2 order-md-1" }, [
          _c("p", { staticClass: "teaser__heading subline subline--bold" }, [
            _vm._v(
              "\n                        " +
                _vm._s(_vm.$t("fanbox.teaserHeadline")) +
                "\n                    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "shop-fanbox__teaser__count" }, [
            _vm._v(
              _vm._s(_vm.fanboxList.length) +
                " " +
                _vm._s(_vm.$t("fanbox.fanboxItems"))
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "teaser__body",
            domProps: { innerHTML: _vm._s(_vm.$t("fanbox.teaserBodytext")) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 order-1 order-md-2" },
          [
            _c("p", { staticClass: "shop-fanbox__badge" }, [
              _vm._v(" " + _vm._s(_vm.$t("fanbox.badge"))),
            ]),
            _vm._v(" "),
            _c("global-responsive-image", {
              attrs: { "responsive-image": _vm.fanboxTeaserImage },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.selectedFanboxItems.length
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("p", { staticClass: "typo-light" }, [
                  _vm._v(_vm._s(_vm.$t("fanbox.selected"))),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.selectedFanboxItems, function (item) {
                return [
                  _c(
                    "shop-tile",
                    {
                      key: item.order_pid,
                      staticClass: "col-12 col-md-6",
                      attrs: { tile: item },
                    },
                    [
                      _c("template", { slot: "button-add2wishlist" }, [
                        _c("span", {
                          staticClass:
                            "wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty",
                          attrs: {
                            "data-pid": item.order_pid,
                            "data-title": item.title,
                            "data-titlesuffix": item.titlesuffix,
                            "data-subtitle": item.subtitle,
                            "data-subsubtitle": item.subsubtitle,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "ordercount" },
                        [
                          _vm.selectFanbox
                            ? [
                                _c("span", { staticClass: "typo-light" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("fanbox.quantity")) +
                                      " " +
                                      _vm._s(
                                        _vm.$store.getters.cartGetCartOrderQuantityForPimId(
                                          item.pim_id
                                        ) || 1
                                      )
                                  ),
                                ]),
                              ]
                            : _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$store.getters.authenticated,
                                      expression:
                                        "$store.getters.authenticated",
                                    },
                                  ],
                                  staticClass: "col-12 ordercount-input",
                                  class: [
                                    _vm.$store.getters.cartCheckErrorItem(
                                      item.pim_id
                                    )
                                      ? "has-error"
                                      : "no-error",
                                  ],
                                },
                                [
                                  _c(
                                    "global-item-quantity",
                                    {
                                      attrs: {
                                        min: 1,
                                        value:
                                          _vm.$store.getters.cartGetCartOrderQuantityForPimId(
                                            item.pim_id
                                          ) || 1,
                                        max: parseInt(_vm.maxOrderItems),
                                        "error-messages": {
                                          errorToSmall: _vm.$t(
                                            "errorItemQuantityMin"
                                          ),
                                          errorToLarge: _vm.$t(
                                            "errorItemQuantityMax"
                                          ),
                                          errorNotANumber: _vm.$t(
                                            "errorItemQuantityEmpty"
                                          ),
                                        },
                                      },
                                      on: {
                                        updateErrorItemQuantity: function (
                                          $event
                                        ) {
                                          return _vm.$store.dispatch(
                                            "addCartErrorItem",
                                            $event
                                          )
                                        },
                                        updateCartData: function ($event) {
                                          return _vm.$store.dispatch(
                                            "changeCartOrderQuantity",
                                            {
                                              pim_id: item.pim_id,
                                              quantity: $event,
                                            }
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "amount" },
                                          slot: "amount",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("orderquantity"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("global-button", {
                                    attrs: {
                                      icon: "trash",
                                      theme: "secondary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$store.dispatch(
                                          "changeCartOrderQuantity",
                                          { pim_id: item.pim_id, quantity: 0 }
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.selectFanbox
                        ? _c("template", { slot: "remove-button" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$store.getters.authenticated ===
                                      false,
                                    expression:
                                      "$store.getters.authenticated === false",
                                  },
                                ],
                                staticClass: "button-wrapper spacer--top",
                              },
                              [
                                _c("global-button", {
                                  attrs: { icon: "trash", theme: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$store.dispatch(
                                        "changeCartOrderQuantity",
                                        { pim_id: item.pim_id, quantity: 0 }
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.unselectedFanboxItems.length
        ? _c(
            "div",
            {
              staticClass: "row fanbox__additional-fans",
              class: _vm.selectFanbox
                ? "shop-fanbox--selected"
                : "shop-fanbox--unselected",
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("p", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("fanbox.otherFanboxItemsHeading"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.unselectedFanboxItems, function (item) {
                return [
                  _c("shop-tile", {
                    key: item.order_pid,
                    staticClass: "col-12 col-md-6",
                    attrs: { tile: item },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "fanbox__select" },
            [
              _c("hr"),
              _vm._v(" "),
              _c("global-input-checkbox", {
                attrs: {
                  label: _vm.$t("fanbox.checkbox.label"),
                  value: _vm.selectFanbox,
                },
                on: { input: _vm.toggleCheckbox },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.selectedNonFanboxItems.length
      ? _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.selectedNonFanboxItems, function (item) {
              return [
                _c(
                  "shop-tile",
                  {
                    key: item.order_pid,
                    staticClass: "col-12 col-md-6",
                    attrs: { tile: item },
                  },
                  [
                    _c("template", { slot: "button-add2wishlist" }, [
                      _c("span", {
                        staticClass:
                          "wish-list link link--primary link--icon icon--small icon--before icon--wishlist-empty",
                        attrs: {
                          "data-pid": item.order_pid,
                          "data-title": item.title,
                          "data-titlesuffix": item.titlesuffix,
                          "data-subtitle": item.subtitle,
                          "data-subsubtitle": item.subsubtitle,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "ordercount" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$store.getters.authenticated,
                              expression: "$store.getters.authenticated",
                            },
                          ],
                          staticClass: "col-12 ordercount-input",
                          class: [
                            _vm.$store.getters.cartCheckErrorItem(item.pim_id)
                              ? "has-error"
                              : "no-error",
                          ],
                        },
                        [
                          _c(
                            "global-item-quantity",
                            {
                              attrs: {
                                min: 1,
                                value:
                                  _vm.$store.getters.cartGetCartOrderQuantityForPimId(
                                    item.pim_id
                                  ),
                                max: parseInt(_vm.maxOrderItems),
                                "error-messages": {
                                  errorToSmall: _vm.$t("errorItemQuantityMin"),
                                  errorToLarge: _vm.$t("errorItemQuantityMax"),
                                  errorNotANumber: _vm.$t(
                                    "errorItemQuantityEmpty"
                                  ),
                                },
                              },
                              on: {
                                updateErrorItemQuantity: function ($event) {
                                  return _vm.$store.dispatch(
                                    "addCartErrorItem",
                                    $event
                                  )
                                },
                                updateCartData: function ($event) {
                                  return _vm.$store.dispatch(
                                    "changeCartOrderQuantity",
                                    { pim_id: item.pim_id, quantity: $event }
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "amount" }, slot: "amount" },
                                [_vm._v(_vm._s(_vm.$t("orderquantity")))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("global-button", {
                            attrs: { icon: "trash", theme: "secondary" },
                            on: {
                              click: function ($event) {
                                return _vm.$store.dispatch(
                                  "changeCartOrderQuantity",
                                  { pim_id: item.pim_id, quantity: 0 }
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("template", { slot: "remove-button" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$store.getters.authenticated === false,
                              expression:
                                "$store.getters.authenticated === false",
                            },
                          ],
                          staticClass: "button-wrapper spacer--top",
                        },
                        [
                          _c("global-button", {
                            attrs: { icon: "trash", theme: "secondary" },
                            on: {
                              click: function ($event) {
                                return _vm.$store.dispatch(
                                  "changeCartOrderQuantity",
                                  { pim_id: item.pim_id, quantity: 0 }
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }